import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_NOT_FOUND, MSG_RATECARD_REQUIRED, MSG_RATECARD_ADD_SUCCESS, MSG_RATECARD_UPDATE_SUCCESS, MSG_RATECARD_DELETE_SUCCESS, MSG_RATECARD_ADD_EDIT_DUPLICATE, MSG_ERROR, MSG_FROM_SERVER } from '../../../configs/msgConfigs'; // 
import { LBL_APP_NAME, LBL_SETTINGS, LBL_RATE_CARD, LBL_RATE_CARDS, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_CONFIRM_DELETE, LBL_CLIENTS, LBL_RATECARD_COPY, LBL_SELECT, LBL_BACK_TO_SETTINGS} from '../../../configs/labelConfigs';
import { ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_SKILL_RATE_CARDS, PAGENUMROWS_AFFILIATE, PAGING_END_INDEX, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs';
import { RATE_CARDS_LIST_AFFILIATE_SUCCESS, RATE_CARDS_ADD_AFFILIATE_SUCCESS, RATE_CARDS_UPDATE_AFFILIATE_SUCCESS, RATE_CARDS_DELETE_AFFILIATE_SUCCESS, RATE_CARDS_ADD_AFFILIATE_ERROR, RATE_CARDS_UPDATE_AFFILIATE_ERROR, RATE_CARDS_DELETE_AFFILIATE_ERROR, RATE_CARDS_ALL_AFFILIATE_SUCCESS, RATE_CARDS_ALL_AFFILIATE_ERROR } from '../../../actions/';

import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';

import { formValid } from '../../../utils/validation';

import { aflt_rateCardsListAction, aflt_rateCardsAllAction, aflt_rateCardsAddAction, aflt_rateCardsUpdateAction, aflt_rateCardsDeleteAction, setDefaultRateCardId } from '../../../actions/settings/affiliates/aflt_rateCardsActions';

import { clearAction } from '../../../actions/commonActions';

class RateCardsComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
            formErrors : {}, 
            rateCardsList: [],
            rateCardsAll: [],
            selRateCardId:0,
            rateCardName: '', 
            rateCardsListErrMsg: '',
            formErrMsg_rateCard: "",
            formErrMsg_AddEdit: '', 
            sortField:'title',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            rcName:'',
            activePage:1,
            startIndex : 0, 
            endIndex : 3,
            perPageCount: PAGENUMROWS_AFFILIATE,
            activeRowId:0,  
            copyRateCardId:0,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.checkFormData = this.checkFormData.bind(this); 
        this.modalDelete = React.createRef();
        this.modalConfirmDelete = React.createRef();
        this.modal = React.createRef();
    }

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        document.title = LBL_APP_NAME+' - '+LBL_SETTINGS+' - '+LBL_RATE_CARDS; 
        this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});     
    }   

    onClickRateCard = (e,rateCardId) => {
        this.props.setDefaultRateCardId(rateCardId); 
        this.props.history.push(ROUTE_AFFILIATE_SKILL_RATE_CARDS); 
    }
    
    openModal(refId) { 
        this.props.aflt_rateCardsAllAction({pageSize:this.state.perPageCount,page:0,column:this.state.sortOrder+this.state.sortField}); 
        if(!refId) {
            this.setState({selRateCardId:0, rateCardName:'', copyRateCardId:0,  formErrMsg_rateCard:MSG_RATECARD_REQUIRED,formErrMsg_AddEdit: ''});
        }
        else {
            if(!refId) {
                this.setState({formErrMsg_AddEdit: ''});
            }
        }
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{   
        this.setState({selRateCardId:0, rateCardName:'', copyRateCardId:0, formErrMsg_rateCard:'', formErrMsg_AddEdit: ''});   
        this.props.clearAction();  
    }

    onModalConfirmReset = () =>{
        this.modalDelete.current.handleModelClose();
        this.setState({selRateCardId:0, rateCardName:'', copyRateCardId:0, formErrMsg_rateCard:'',formErrMsg_AddEdit: ''});   
        this.props.clearAction();  
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.aflt_appayrateListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.aflt_appayrateListAction({column:this.state.sortOrder+sortKey});
        }        
    }

    onPagePrevious = (e) =>{
        const { startIndex, endIndex } = this.state;
        let previousPage = startIndex+1-PAGING_END_INDEX;
        this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField});
        if(startIndex===0){
            this.setState({
                activePage: previousPage,
                startIndex : startIndex,
                endIndex : endIndex
            });  
        }else{
            this.setState({
                activePage: previousPage,
                startIndex : startIndex - PAGING_END_INDEX,
                endIndex : endIndex - PAGING_END_INDEX
            });  
        }                               
    }

    onPageUp = (e) => { 
        this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField});
        this.setState({
            activePage: Number(e.target.id)                   
        });
    }
    
    onPageNext = (e) =>{   
        const { startIndex,endIndex } = this.state;      
        const { totalPage } = this.props;      
        let nextPage = startIndex+1+PAGING_END_INDEX; 
        this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField});
        if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
            this.setState({
                activePage: nextPage,
                startIndex : startIndex,
                endIndex : endIndex
            }); 
        }else{
            this.setState({
                activePage: nextPage,
                startIndex : startIndex + PAGING_END_INDEX,
                endIndex : endIndex + PAGING_END_INDEX
            });  
        }                            
    }

    editBtnClick = (refId) =>{  
        this.props.rateCardsList.forEach((rObj) => {
            if(refId===rObj.id) {
                this.setState({selRateCardId:rObj.id, rateCardName:rObj.title, formErrMsg_rateCard:''}, () => {
                    this.openModal(rObj.id); 
                })
            }
        }); 
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({selRateCardId:rowId, rcName:name}, () => this.modalDelete.current.handleOpenModal()); 
    }

    onDeleteAction = () =>{
        this.props.aflt_rateCardsDeleteAction({rateCardId:this.state.selRateCardId});
    }

    onDeleteConfrimAction = () =>{
        this.props.aflt_rateCardsDeleteAction({rateCardId:this.state.selRateCardId,confirm:true});              
    }
    
    onHandleChange = (event) =>{
        const {name, value} = event.target; 
        let errMsg = ''; 
        let valStr = value; //.trim(); 
        if(name==='txt_rateCard') { 
            if(valStr.trim()==='') errMsg = MSG_RATECARD_REQUIRED; 
            this.setState({rateCardName:valStr, formErrMsg_rateCard: errMsg,formErrMsg_AddEdit: '',});  
        }  
        else if(name==='copyRateCardId') {
            this.setState({copyRateCardId:valStr});  
        }
    }  

    checkFormData() {
        if(this.state.rateCardName.trim()==='') {  
            this.setState({formErrMsg_rateCard:MSG_RATECARD_REQUIRED, formErrMsg_AddEdit: '',});  
            return false; 
        } 
        else {
            return true; 
        }
    }

    onSaveFormData = (refId) =>{ 
        if(formValid(this.state)){
            let rateCardName = this.state.rateCardName.trim(); 
            let userGroupData = userGroupUrlCheck(this.props.location);
            let grpProfileId = '';
            if(userGroupData!==undefined){
                grpProfileId = userGroupData.profile_id;
            }
            if(refId){ // EDIT 
                if(this.checkFormData()) { 
                    const checkDuplicate = obj => refId!==obj.id && obj.title === rateCardName.trim();
                    if(this.props.rateCardsList.some(checkDuplicate)){
                        this.setState({formErrMsg_rateCard:MSG_RATECARD_ADD_EDIT_DUPLICATE});
                    }else{
                        let affiliate = grpProfileId;
                        let editData= {}
                        if(this.state.copyRateCardId && this.state.copyRateCardId > 0) {
                            editData= {
                                id: this.state.selRateCardId, 
                                title: this.state.rateCardName, 
                                affiliate: affiliate,
                                copy_from_id: parseInt(this.state.copyRateCardId,10)
                            } 
                            this.props.aflt_rateCardsUpdateAction(editData);
                        }
                        else {
                            editData= {
                                id: this.state.selRateCardId, 
                                title: this.state.rateCardName, 
                                affiliate: affiliate,
                            } 
                            this.props.aflt_rateCardsUpdateAction(editData);
                        }    
                    }                    
                }
            }else if(this.checkFormData()) {
                const checkDuplicate = obj => obj.title === rateCardName.trim();
                if(this.props.rateCardsList.some(checkDuplicate)){
                    this.setState({formErrMsg_rateCard:MSG_RATECARD_ADD_EDIT_DUPLICATE});
                }else{
                    let affiliate = grpProfileId;
                    let addData= {}
                    if(this.state.copyRateCardId && this.state.copyRateCardId > 0) {
                        addData= {
                            title: this.state.rateCardName, 
                            affiliate: affiliate,
                            copy_from_id: parseInt(this.state.copyRateCardId,10)    
                        }
                        this.props.aflt_rateCardsAddAction(addData);
                    }
                    else {   
                        addData= {
                            title: this.state.rateCardName, 
                            affiliate: affiliate
                        }   
                        this.props.aflt_rateCardsAddAction(addData);         
                    }  
                }            
            }    
        }else{
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) {       
        const { status,activity,errorData,totalPage,numRows,} = this.props;
        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 
                let errMsg = '';

                if(actString===RATE_CARDS_LIST_AFFILIATE_SUCCESS){
                    if(this.props.hasOwnProperty('rateCardsList')) {
                        if(this.props.rateCardsList.length===0) {
                            this.setState({rateCardsList: []}); 
                        }
                        else {
                            this.setState({rateCardsList: this.props.rateCardsList}); 
                        }
                    } 
                    else {
                        this.setState({rateCardsList: []}); 
                    }
                } 
                else if(actString===RATE_CARDS_ALL_AFFILIATE_SUCCESS){
                    if(this.props.hasOwnProperty('rateCardsAll')) {
                        if(this.props.rateCardsAll.length===0) {
                            this.setState({rateCardsAll: []}); 
                        }
                        else {
                            this.setState({rateCardsAll: this.props.rateCardsAll}); 
                        }
                    } 
                    else {
                        this.setState({rateCardsAll: []}); 
                    }
                } 
                else if(actString===RATE_CARDS_ADD_AFFILIATE_SUCCESS){ 
                    this.onModalFormReset();
                    this.modal.current.handleModelClose();
                    this.setState({toastSuccess:true,toastFlag:true,toastMessage:MSG_RATECARD_ADD_SUCCESS}, () => this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField}));
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                } 
                else if(actString===RATE_CARDS_ADD_AFFILIATE_ERROR) { 
                    if(status===400){
                        let msgCode = errorData.hasOwnProperty('title') ? errorData.title : ''; 
                        if(msgCode && msgCode[0] && MSG_FROM_SERVER[msgCode[0]]) {
                            errMsg = MSG_FROM_SERVER[msgCode[0]];
                        }
                        else {
                            errMsg = MSG_RATECARD_ADD_EDIT_DUPLICATE;  
                        }
                        this.setState({formErrMsg_AddEdit: errMsg}); 
                    }else{
                        errMsg = MSG_ERROR;
                        this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_rateCard: ''}); 
                    }
                } 
                else if(actString===RATE_CARDS_UPDATE_AFFILIATE_SUCCESS){ 
                    this.onModalFormReset();
                    this.modal.current.handleModelClose();
                    this.setState({rateCardsList:this.props.rateCardsList, toastSuccess:true, toastFlag:true,toastMessage:MSG_RATECARD_UPDATE_SUCCESS}); 
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else if(actString===RATE_CARDS_UPDATE_AFFILIATE_ERROR) { 
                    if(status===400){
                        let msgCode = errorData.hasOwnProperty('title') ? errorData.title : ''; 
                        if(msgCode && msgCode[0] && MSG_FROM_SERVER[msgCode[0]]) {
                            errMsg = MSG_FROM_SERVER[msgCode[0]];
                        }
                        else {
                            errMsg = MSG_RATECARD_ADD_EDIT_DUPLICATE;  
                        }
                        this.setState({formErrMsg_AddEdit: errMsg}); 
                    }else{
                        errMsg = MSG_ERROR;
                        this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_rateCard: ''}); 
                    }
                }  
                else if(actString===RATE_CARDS_DELETE_AFFILIATE_SUCCESS){ 
                    this.modalDelete.current.handleModelClose();
                    this.modalConfirmDelete.current.handleModelClose();
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_RATECARD_DELETE_SUCCESS}, () => this.props.aflt_rateCardsListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField}));
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else if(actString===RATE_CARDS_DELETE_AFFILIATE_ERROR) { 
                    if(status===424){
                        this.modalDelete.current.handleModelClose();
                        this.setToasterState(true,errorData.message,false);
                        // this.modalConfirmDelete.current.handleOpenModal();
                        // if(errorData.hasOwnProperty('confirmation_message')){
                        //     if(errorData.confirmation_message===true){
                        //         this.setState({selRateCardId:errorData.id});
                        //     }else{
                        //         this.setState({selRateCardId:0});
                        //     }
                        // }
                    }else{
                        this.modalDelete.current.handleModelClose();
                        this.setToasterState(true,JSON.stringify(errorData),false); 
                    }
                } 

            }
        }
    }
    
       
    render(){
        const { activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess } = this.state

        const { totalPage,status } = this.props;  

        if(status===401 || status===403){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-right-20 padding-top-10 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                        <div className="to-right">
                        <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        {/* { onClick={(e) => this.onSort(e,'ap_from')} className="sorting_asc" } */}
                                        <th>{LBL_SLNUM}</th>
                                        <th>{LBL_RATE_CARD}</th>
                                        <th>{LBL_CLIENTS}</th>
                                        <th className="action">&nbsp;</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.state.rateCardsListErrMsg!=='') && 
                                    <tr key="errorMsg">
                                        <td colSpan="5" className="text-center">{this.state.rateCardsListErrMsg}</td>
                                    </tr>
                                }
                                 {this.state.hasOwnProperty('rateCardsList') && this.state.rateCardsList.map((item,index) => { 
                                    return (
                                    <tr key={item.id}> 
                                        <td>{(PAGENUMROWS_AFFILIATE*(this.state.activePage-1))+(index+1)}</td>
                                        <td><Link to='#'><div onClick={(e) => this.onClickRateCard(e,item.id)}>{item.title}</div></Link></td>
                                        <td>{item.client_name.join(", ")}</td>
                                        <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+item.id}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                 >
                                                <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+item.id} id={'dropdown-menu-'+item.id}>
                                                <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>
                                                <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.title)}>Delete</Link>
                                                </div>
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                    ) } ) }
                                </tbody>
                            </table>
                            <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <br></br>
                        </div>
                    </div>
                </div>
                

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete "+LBL_RATE_CARD+" '"+this.state.rcName+"'?"}
                </ModalWindow>

                <ModalWindow ref={this.modalConfirmDelete} header={LBL_CONFIRM_DELETE} type="confirm" deleteConfirmedItem={this.onDeleteConfrimAction} resetModalForm={this.onModalConfirmReset}>
                    {"This "+LBL_RATE_CARD+" has already been used in another module, do you still want to delete this record?"}
                </ModalWindow>

                <ModalWindow ref={this.modal} header={"Add/Edit "+LBL_RATE_CARD} saveFormData={ (e)=>this.onSaveFormData(this.state.selRateCardId)} resetModalForm={this.onModalFormReset}> 
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_RATE_CARD}</label>
                                <div className="text-input">
                                    <input type="text" placeholder={LBL_RATE_CARD} name="txt_rateCard" value={this.state.rateCardName} onChange={this.onHandleChange} maxLength = {120} className={(this.state.formErrMsg_rateCard.length >0 ? "input-error" : ' ')} />
                                </div>
                                {this.state.formErrMsg_AddEdit.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_AddEdit}</div>
                                    )} 
                            </div>
                        </div> 
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_RATECARD_COPY}</label>
                                <div className="form-group select-input">
                                    <select name="copyRateCardId" onChange={this.onHandleChange} value={this.state.copyRateCardId} >
                                        <option value=''>{LBL_SELECT+' '+LBL_RATE_CARD}</option>
                                        {this.state.rateCardsAll.map((item) => {
                                            if(item.id!==this.state.selRateCardId) {
                                                return(<option key={item.id} value={item.id}>{item.title}</option>)
                                            }})}
                                    </select>
                                </div>
                            </div>
                        </div> 
                   </div> 
                </ModalWindow>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        rateCardsList : state.afltRateCards.rateCardsList,
        rateCardsAll : state.afltRateCards.rateCardsAll, 
        status:state.afltRateCards.status,
        activity:state.afltRateCards.activity,
        errorData: state.afltRateCards.errorData,
        totalPage:state.afltRateCards.totalPage,
        numRows:state.afltRateCards.numRows,
        loadDefaultRateCardId:state.afltRateCards.loadDefaultRateCardId,
    } 
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_rateCardsListAction:data=>aflt_rateCardsListAction(data),  
        aflt_rateCardsAllAction:data=>aflt_rateCardsAllAction(data),  
        aflt_rateCardsAddAction:data=>aflt_rateCardsAddAction(data),
        aflt_rateCardsUpdateAction:data=>aflt_rateCardsUpdateAction(data),
        aflt_rateCardsDeleteAction:id=>aflt_rateCardsDeleteAction(id),
        setDefaultRateCardId:data=>setDefaultRateCardId(data), 
        clearAction:clearAction
    },dispatch); 
} 
export default connect(mapStateToProps,mapDispatchToProps)(RateCardsComponent);


